<template>
	<v-sheet flat>
		<mw-edit
			:id="id"
			storeModule="categoryOptions"
			:model="model"
			@saved="$emit('saved')"
		>
		</mw-edit>
	</v-sheet>
</template>

<style lang="less"></style>

<script type="text/javascript">
import CategoryOption from "@//models/CategoryOption";
import MwEdit from "@c/ui/MwEdit";

export default {
	name: "EditCategoryOption",
	props: {
		id: { type: String }, // @doc the id string of the object - will add a new document if not passed
	},
	computed: {
		model() {
			return CategoryOption;
		},
	},
	components: {
		MwEdit,
	},
};
//
</script>
"
